type NavItem = {
  key: string;
  path: string;
  title: string;
};

export const filterNavItems = (
  items: NavItem[],
  allowedPages?: Record<string, boolean>,
  externalCurrencyEnabled?: boolean
) => {
  if (!allowedPages) return items;

  return items.filter((item) => {
    if (externalCurrencyEnabled && item.key === 'buy_points') {
      return false;
    }
    
    const allowed = allowedPages[item.key];
    return allowed === undefined || allowed === true;
  });
};
